import { Extension } from "@codemirror/state";
import {
  Decoration,
  DecorationSet,
  EditorView,
  ViewPlugin,
  ViewUpdate
} from "@codemirror/view";
import { RangeSetBuilder } from "@codemirror/state";

// Highlight "macros" or "_self" within Twig brackets

// This matches: {{ macros.something() }} or {{ _self.something() }}
const TWIG_SPECIAL_WORDS_REGEX = /\{\{\s*(macros|_self)\b/g;

// Decoration for special Twig words
const twigSpecialWordDecoration = Decoration.mark({
  class: "cm-twig-special-word",
  attributes: { title: "Twig Special Word" }
});

// Plugin to highlight special Twig words
const twigSpecialWordsPlugin = ViewPlugin.fromClass(
  class {
    decorations: DecorationSet;

    constructor(view: EditorView) {
      this.decorations = this.buildDecorations(view);
    }

    update(update: ViewUpdate) {
      if (update.docChanged || update.viewportChanged) {
        this.decorations = this.buildDecorations(update.view);
      }
    }

    buildDecorations(view: EditorView): DecorationSet {
      const builder = new RangeSetBuilder<Decoration>();
      const doc = view.state.doc;

      for (const { from, to } of view.visibleRanges) {
        const text = doc.sliceString(from, to);
        let match;
        let lastIndex = 0;

        // Reset regex state
        TWIG_SPECIAL_WORDS_REGEX.lastIndex = 0;

        while ((match = TWIG_SPECIAL_WORDS_REGEX.exec(text)) !== null) {
          const specialWord = match[1]; // "macros" or "_self"
          const wordStart = from + match.index + match[0].indexOf(specialWord);
          const wordEnd = wordStart + specialWord.length;

          // Ensure we don't have overlapping decorations
          if (wordStart >= lastIndex) {
            builder.add(wordStart, wordEnd, twigSpecialWordDecoration);
            lastIndex = wordEnd;
          }
        }
      }

      return builder.finish();
    }
  },
  {
    decorations: v => v.decorations
  }
);

export const twigSpecialWordsParser: Extension = [
  twigSpecialWordsPlugin,
  EditorView.theme({
    ".cm-twig-special-word, .cm-twig-special-word *": {
      color: "#ff79c6"
    }
  })
];
